"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var cssParse = require("./css-parse.js");
var _require = require("lodash"),
  get = _require.get;
var _require2 = require("docxtemplater"),
  Errors = _require2.Errors;
var _require3 = require("./regex.js"),
  sizeRegex = _require3.sizeRegex;
var isValidColor = require("color-js").isValid;
var borderStyles = ["dotted", "solid", "dashed", "double", "outset", "none", "inset"];
var listStyleToNumFmt = {
  none: "none",
  "decimal-leading-zero": "decimalZero",
  decimal: "decimal",
  "lower-alpha": "lowerLetter",
  "lower-latin": "lowerLetter",
  "upper-alpha": "upperLetter",
  "upper-latin": "upperLetter",
  "lower-roman": "lowerRoman",
  "upper-roman": "upperRoman"
};
function directionHandler(values, str, functor) {
  if (values.length === 3) {
    functor({
      property: str.replace("*", "top"),
      value: values[0]
    });
    functor({
      property: str.replace("*", "right"),
      value: values[1]
    });
    functor({
      property: str.replace("*", "left"),
      value: values[1]
    });
    functor({
      property: str.replace("*", "bottom"),
      value: values[2]
    });
    return;
  }
  if (values.length === 4) {
    functor({
      property: str.replace("*", "top"),
      value: values[0]
    });
    functor({
      property: str.replace("*", "right"),
      value: values[1]
    });
    functor({
      property: str.replace("*", "bottom"),
      value: values[2]
    });
    functor({
      property: str.replace("*", "left"),
      value: values[3]
    });
    return;
  }
  if (values.length === 2) {
    functor({
      property: str.replace("*", "top"),
      value: values[0]
    });
    functor({
      property: str.replace("*", "bottom"),
      value: values[0]
    });
    functor({
      property: str.replace("*", "right"),
      value: values[1]
    });
    functor({
      property: str.replace("*", "left"),
      value: values[1]
    });
    return;
  }
  if (values.length === 1) {
    functor({
      property: str.replace("*", "top"),
      value: values[0]
    });
    functor({
      property: str.replace("*", "bottom"),
      value: values[0]
    });
    functor({
      property: str.replace("*", "right"),
      value: values[0]
    });
    functor({
      property: str.replace("*", "left"),
      value: values[0]
    });
    return;
  }
}
function getDeclarations(element, transformer, style) {
  style = style.replace(/&#58;/g, ":");
  try {
    var result = cssParse("body { ".concat(style, " }"), _objectSpread(_objectSpread({}, transformer), {}, {
      source: "inline-style"
    }));
    if (result.errors) {
      transformer.collectErrors(result.errors);
    }
    return result.parsed.stylesheet.rules[0].declarations;
  } catch (e) {
    var err = new Errors.RenderingError("Style for element cannot be parsed");
    err.properties = {
      explanation: "The tag ".concat(element.name, " contains invalid style properties"),
      name: element.name,
      style: style,
      id: "style_property_invalid"
    };
    throw err;
  }
}
function forEachStyleDeclarationInherited(element, transformer, functor) {
  if (element.parent) {
    forEachStyleDeclarationInherited(element.parent, transformer, functor);
  }
  forEachStyleDeclaration(element, transformer, functor);
}
function forEachStyleDeclaration(element, transformer, functor) {
  if (_typeof(element) !== "object") {
    throw new Error("Element in forEachStyleDeclaration should be an object, given ".concat(_typeof(element)));
  }
  var stdStyle = get(element, "attribs.style");
  var htmlStyle = get(element, "customProperties.htmlStyle");
  if (!stdStyle && !htmlStyle) {
    element.parsedStyle = [];
    return;
  }
  var declarations = [];
  if (element.parsedStyle) {
    declarations = element.parsedStyle;
  } else {
    if (stdStyle) {
      declarations = declarations.concat(getDeclarations(element, transformer, stdStyle));
    }
    if (htmlStyle) {
      declarations = declarations.concat(getDeclarations(element, transformer, htmlStyle));
    }
    declarations = declarations.filter(function (d) {
      return _typeof(d) === "object";
    });
  }
  element.parsedStyle = declarations;

  // put line-height to the bottom, because we want to parse font-size first, then line-height.
  var sortedDeclarations = declarations.sort(function (dec1, dec2) {
    if (dec1.property === "line-height") {
      return 1;
    }
    if (dec2.property === "line-height") {
      return -1;
    }
    return 0;
  });

  // eslint-disable-next-line complexity
  sortedDeclarations.forEach(function (declaration) {
    var property = declaration.property,
      value = declaration.value;
    var values = value.split(/ +/);
    if (property === "padding") {
      directionHandler(values, "padding-*", functor);
    }
    if (property === "list-style") {
      if (listStyleToNumFmt[values[0]]) {
        functor({
          property: "list-style-type",
          value: values[0]
        });
      }
      if (listStyleToNumFmt[values[1]]) {
        functor({
          property: "list-style-type",
          value: values[1]
        });
      }
      if (listStyleToNumFmt[values[2]]) {
        functor({
          property: "list-style-type",
          value: values[2]
        });
      }
    }
    if (property === "margin") {
      directionHandler(values, "margin-*", functor);
    }
    if (property === "border-style") {
      functor({
        property: "border-style",
        value: value
      });
      directionHandler(values, "border-*-style", functor);
    }
    if (property === "border") {
      values.forEach(function (value) {
        if (borderStyles.indexOf(value) !== -1) {
          functor({
            property: "border-style",
            value: value
          });
          functor({
            property: "border-left-style",
            value: value
          });
          functor({
            property: "border-right-style",
            value: value
          });
          functor({
            property: "border-top-style",
            value: value
          });
          functor({
            property: "border-bottom-style",
            value: value
          });
          return;
        }
        if (sizeRegex.test(value)) {
          functor({
            property: "border-left-width",
            value: value
          });
          functor({
            property: "border-right-width",
            value: value
          });
          functor({
            property: "border-top-width",
            value: value
          });
          functor({
            property: "border-bottom-width",
            value: value
          });
          return;
        }
        if (isValidColor(value)) {
          functor({
            property: "border-color",
            value: value
          });
          functor({
            property: "border-left-color",
            value: value
          });
          functor({
            property: "border-right-color",
            value: value
          });
          functor({
            property: "border-top-color",
            value: value
          });
          functor({
            property: "border-bottom-color",
            value: value
          });
          return;
        }
      });
      return;
    }
    if (property === "border-width") {
      directionHandler(values, "border-*-width", functor);
    }
    if (property === "border-color") {
      if (isValidColor(value)) {
        functor({
          property: "border-color",
          value: value
        });
        functor({
          property: "border-left-color",
          value: value
        });
        functor({
          property: "border-right-color",
          value: value
        });
        functor({
          property: "border-top-color",
          value: value
        });
        functor({
          property: "border-bottom-color",
          value: value
        });
        return;
      }
    }
    if (property === "border-bottom") {
      values.forEach(function (value) {
        if (borderStyles.indexOf(value) !== -1) {
          functor({
            property: "border-bottom-style",
            value: value
          });
          return;
        }
        if (sizeRegex.test(value)) {
          functor({
            property: "border-bottom-width",
            value: value
          });
          return;
        }
        if (isValidColor(value)) {
          functor({
            property: "border-bottom-color",
            value: value
          });
          return;
        }
      });
      return;
    }
    if (property === "border-right") {
      values.forEach(function (value) {
        if (borderStyles.indexOf(value) !== -1) {
          functor({
            property: "border-right-style",
            value: value
          });
          return;
        }
        if (sizeRegex.test(value)) {
          functor({
            property: "border-right-width",
            value: value
          });
          return;
        }
        if (isValidColor(value)) {
          functor({
            property: "border-right-color",
            value: value
          });
          return;
        }
      });
      return;
    }
    if (property === "border-left") {
      values.forEach(function (value) {
        if (borderStyles.indexOf(value) !== -1) {
          functor({
            property: "border-left-style",
            value: value
          });
          return;
        }
        if (sizeRegex.test(value)) {
          functor({
            property: "border-left-width",
            value: value
          });
          return;
        }
        if (isValidColor(value)) {
          functor({
            property: "border-left-color",
            value: value
          });
          return;
        }
      });
      return;
    }
    if (property === "border-top") {
      values.forEach(function (value) {
        if (borderStyles.indexOf(value) !== -1) {
          functor({
            property: "border-top-style",
            value: value
          });
          return;
        }
        if (sizeRegex.test(value)) {
          functor({
            property: "border-top-width",
            value: value
          });
          return;
        }
        if (isValidColor(value)) {
          functor({
            property: "border-top-color",
            value: value
          });
          return;
        }
      });
      return;
    }
    functor(declaration);
  });
}
module.exports = {
  forEachStyleDeclaration: forEachStyleDeclaration,
  forEachStyleDeclarationInherited: forEachStyleDeclarationInherited,
  listStyleToNumFmt: listStyleToNumFmt
};